import { useEffect } from 'react';
import { useDisplayController } from '@/hooks/useDisplayController';
import { useFullscreen } from '@/hooks/useFullscreen';
import { PairingScreen } from '@/components/PairingScreen';
import { HoldingScreen } from '@/components/HoldingScreen';
import { Rotator } from '@/components/Rotator';

export default function App() {
  const state = useDisplayController();
  const { requestNow } = useFullscreen();

  // Try fullscreen the moment we leave the pairing screen (AC: "after pairing completes").
  useEffect(() => {
    if (state.phase === 'rotator' || state.phase === 'holding') requestNow();
  }, [state.phase, requestNow]);

  // Hide the cursor while content is playing; show it on the pairing screen for setup.
  useEffect(() => {
    document.body.dataset.mode = state.phase;
  }, [state.phase]);

  return (
    <div className="app">
      {state.phase === 'booting' && <PairingScreen code={null} />}
      {state.phase === 'pairing' && <PairingScreen code={state.pairingCode} />}
      {state.phase === 'holding' && <HoldingScreen />}
      {state.phase === 'rotator' && <Rotator playlist={state.playlist} />}
    </div>
  );
}
